/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetSkippedUsersResponseDto } from '../models';
// @ts-ignore
import type { GetUserDetailsResponseDto } from '../models';
// @ts-ignore
import type { GetUsersShortResponseDto } from '../models';
/**
 * UsersRestApi - axios parameter creator
 */
export const UsersRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get skipped users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSkippedUsers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/skipped`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get details of a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDetails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get short details of a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersShort: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/short`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersRestApi - functional programming interface
 */
export const UsersRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get skipped users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSkippedUsers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSkippedUsersResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSkippedUsers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersRestApi.getSkippedUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get details of a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserDetails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserDetailsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserDetails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersRestApi.getUserDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get short details of a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersShort(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUsersShortResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersShort(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersRestApi.getUsersShort']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersRestApi - factory interface
 */
export const UsersRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Get skipped users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSkippedUsers(options?: RawAxiosRequestConfig): AxiosPromise<GetSkippedUsersResponseDto> {
            return localVarFp.getSkippedUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get details of a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDetails(options?: RawAxiosRequestConfig): AxiosPromise<GetUserDetailsResponseDto> {
            return localVarFp.getUserDetails(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get short details of a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersShort(options?: RawAxiosRequestConfig): AxiosPromise<GetUsersShortResponseDto> {
            return localVarFp.getUsersShort(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersRestApi - interface
 */
export interface UsersRestApiInterface {
    /**
     * 
     * @summary Get skipped users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSkippedUsers(options?: RawAxiosRequestConfig): AxiosPromise<GetSkippedUsersResponseDto>;

    /**
     * 
     * @summary Get details of a user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserDetails(options?: RawAxiosRequestConfig): AxiosPromise<GetUserDetailsResponseDto>;

    /**
     * 
     * @summary Get short details of a user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUsersShort(options?: RawAxiosRequestConfig): AxiosPromise<GetUsersShortResponseDto>;

}

/**
 * UsersRestApi - object-oriented interface
 */
export class UsersRestApi extends BaseAPI implements UsersRestApiInterface {
    /**
     * 
     * @summary Get skipped users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSkippedUsers(options?: RawAxiosRequestConfig) {
        return UsersRestApiFp(this.configuration).getSkippedUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get details of a user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserDetails(options?: RawAxiosRequestConfig) {
        return UsersRestApiFp(this.configuration).getUserDetails(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get short details of a user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUsersShort(options?: RawAxiosRequestConfig) {
        return UsersRestApiFp(this.configuration).getUsersShort(options).then((request) => request(this.axios, this.basePath));
    }
}

